'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const template = require('../templates/ad.ejs');
const { isMobile } = require('../util/is-mobile');

module.exports = Backbone.View.extend({
    className: 'view-ad',
    events: {},
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.categoryIndex = options.categoryIndex;
        this.adTag = options.adTag;

        const adType = isMobile.any() ? "mobile_mpu_inc" : "mpu_inc";
        this.adId = adType + '-' + this.categoryIndex;
        this.adConfig = [ adType, this.categoryIndex, {pos: "inc"}];
    },
    /**
     *
     */
    render: function () {
        this.$el.html(template({
            adId: this.adId
        }));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        this.model.createAd(this.adConfig, this.adTag);
    },

    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function () {
        this.model.removeAd(this.adId);
        this.model = null;

        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/ad.js